const TEXT = 'text';
const IMAGE = 'image';
const LINK = 'link';
const VIDEO = 'video';
const MENTION = 'user-mention';
const FRAME = 'frame';
const ANIMATION = 'animation';
const TITLE = 'title';

// Media entity is an entity that doesn't rely on the text and act as an attachment
export function isMediaEntity(type) {
  return [IMAGE, LINK, VIDEO, FRAME, ANIMATION].indexOf(type) > -1;
}

export { TEXT, IMAGE, LINK, VIDEO, MENTION, FRAME, ANIMATION, TITLE };
